import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  FormTab,
  FunctionField,
  List,
  NumberInput,
  required,
  SearchInput,
  TextField,
} from "react-admin";
import { useCommonLabels } from "../i18n/hooks";
import { FilePreviewLink } from "../ui/fileUpload";
import { FormSection } from "../ui/forms/FormSection";
import { DescriptionLangFields, TitleLangFields } from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";
import { LocalizedFileControls, LocalizedFileLangField } from "../ui/forms/LocalizedFileInput";
import { normalizeContentRecord } from "../ui/forms/normalizeMedia";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

const PhBreathingForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Параметры">
          <NumberInput source="SortOrder" label="Порядок" defaultValue={0} fullWidth />
          <NumberInput
            source="DurationMin"
            label="Длительность (мин)"
            min={1}
            max={60}
            defaultValue={5}
            validate={required()}
            fullWidth
          />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
        <FormSection title="Изображение">
          <LocalizedFileControls
            baseSource="Image"
            label={c.image}
            kind="image"
            required
            helperText="JPG/PNG — загрузка через файловый сервис"
          />
        </FormSection>
        <FormSection title="Фоновая музыка">
          <LocalizedFileControls
            baseSource="BackgroundMusic"
            label="Фон (MP3)"
            kind="audio"
            accept="audio/*"
            helperText="Опционально — играет во время упражнения, можно выключить кнопкой mute"
          />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <TitleLangFields lang="AZ" titleRequired />
        <DescriptionLangFields lang="AZ" rows={4} />
        <LocalizedFileLangField baseSource="Image" lang="AZ" label={c.image} kind="image" required />
        <LocalizedFileLangField
          baseSource="BackgroundMusic"
          lang="AZ"
          label="Фон (MP3)"
          kind="audio"
          accept="audio/*"
        />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <TitleLangFields lang="RU" titleRequired />
        <DescriptionLangFields lang="RU" rows={4} />
        <LocalizedFileLangField baseSource="Image" lang="RU" label={c.image} kind="image" required />
        <LocalizedFileLangField
          baseSource="BackgroundMusic"
          lang="RU"
          label="Фон (MP3)"
          kind="audio"
          accept="audio/*"
        />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <TitleLangFields lang="EN" titleRequired />
        <DescriptionLangFields lang="EN" rows={4} />
        <LocalizedFileLangField baseSource="Image" lang="EN" label={c.image} kind="image" />
        <LocalizedFileLangField
          baseSource="BackgroundMusic"
          lang="EN"
          label="Background (MP3)"
          kind="audio"
          accept="audio/*"
        />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhBreathingList = () => {
  const c = useCommonLabels();
  return (
    <List filters={filters} sort={{ field: "SortOrder", order: "DESC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="Id" label="ID" />
        <TextField source="TitleRU" label="Название" />
        <TextField source="DurationMin" label="Мин" />
        <TextField source="SortOrder" label="Порядок" />
        <FunctionField
          label={c.image}
          render={(record: { Image?: string }) => <FilePreviewLink value={record.Image} />}
        />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhBreathingEdit = () => (
  <Edit mutationMode="pessimistic" transform={normalizeContentRecord}>
    <PhBreathingForm />
  </Edit>
);

export const PhBreathingCreate = () => (
  <Create transform={normalizeContentRecord}>
    <PhBreathingForm />
  </Create>
);
